<template>
    <div>
        <el-pagination
        @size-change="set_limit"
        @current-change="set_page"
        :page-sizes="[1,10, 20, 30, 40, 50, 100]"
        :current-page="page"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="data_obj.total">
        </el-pagination>
    </div>
</template>

<script>
export default {
    props:{
        data_obj:{
            type:Object
        },
        limit:{
            type:Number
        },
        page:{
            type:Number
        },
        is_search:{
            type:Boolean
        }
    },
    data(){
        return {
            is_limit:false
        }
    },
    methods:{
        set_page(page){
            this.$emit('set_page',page)
            if(!this.is_search){
                //console.log('触发set_page222',this.limit)
                let page_data = {}
                if(sessionStorage.getItem('page_data')){
                    page_data = JSON.parse(sessionStorage.getItem('page_data'))
                }
                page_data[this.$route.path] = page
                sessionStorage.setItem('page_data',JSON.stringify(page_data))

                
                if(!this.is_limit){
                    let limit_data = {}
                    if(sessionStorage.getItem('limit_data')){
                        limit_data = JSON.parse(sessionStorage.getItem('limit_data'))
                    }
                    limit_data[this.$route.path] = this.limit
                    sessionStorage.setItem('limit_data',JSON.stringify(limit_data))
                }
            }
        },
        set_limit(limit){
            this.$emit('set_limit',limit)
            if(!this.is_search){

                this.is_limit = true

                //console.log('触发set_limit 111',limit)
                let limit_data = {}
                if(sessionStorage.getItem('limit_data')){
                    limit_data = JSON.parse(sessionStorage.getItem('limit_data'))
                }
                limit_data[this.$route.path] = limit
                sessionStorage.setItem('limit_data',JSON.stringify(limit_data))
            }
            this.set_page(1)
        }
    }
}
</script>
